import { Route, Routes } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import ResetPasswordScreen from './views/ResetPasswordFormView';



function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/resetPassword/:resetToken" element={<ResetPasswordScreen />} />
      </Routes>
    </BrowserRouter>
  );
}



export default App;
